import Carousel from 'Assets/js/lib/carousel'
;(function () {
  const components = {
    dynamicRecommendations: SAXX.Init.Component((node) => {
      const cardTarget = node.querySelector('[data-loading-target]')
      const url = node.getAttribute('data-url')

      fetch(url)
        .then((res) => {
          if (!res.ok) throw new Error(`Fetch error! ${res.status}`)
          return res.text()
        })
        .then((response) => {
          const section = new DOMParser().parseFromString(response, 'text/html')
          cardTarget.innerHTML = section.querySelector(
            '[data-loading-target]',
          ).innerHTML

          const template = node.querySelector('#cta-card-template')
          if (template) {
            node
              .querySelector('[data-loading-target]')
              .appendChild(template.content.cloneNode(true))
          }

          if (node.classList.contains('carousel')) {
            new Carousel(node, { cell: '.product-card' })
          }
        })
        .catch((e) => {
          console.error(e)
          node.closest('.recommended-products').classList.add('no-placement')
        })
        .finally(() => {
          node.closest('.recommended-products').classList.remove('loading')
        })
    }),
    recommendations: SAXX.Init.Component((node) => {
      const template = node.querySelector('#cta-card-template')
      if (template) {
        node
          .querySelector('[data-loading-target]')
          .appendChild(template.content.cloneNode(true))
      }

      if (node.classList.contains('carousel')) {
        new Carousel(node, { cell: '.product-card' })
      }
    }),
  }

  Object.assign(SAXX.Init.Components, components)
})()
